import {
  createServer,
  Model,
  hasMany,
  belongsTo
} from 'miragejs';
import {buildUrlWithAdminImpersonation} from "./utilities/helpers";

const userDb = [
  {
    alphaFactor: 50,
    bidMode: 'MANUAL',
    crewGroup: 'cabin',
    crewInterfaceLastUse: 1667590399477,
    currentCategory: null,
    initialCredit: 0,
    language: { code: 'EN', name: 'English' },
    loadStanding: false,
    lockoutExpiryDateLbt: null,
    maximumBlockTime: null,
    minimumBlockTime: null,
    name: 'Mock Server Administrator',
    plannerNote: null,
    previousPeriodCredit: 0,
    profileLastSave: null,
    relativeSeniority: null,
    staffId: 'Admin',
    standingBidSessionId: 3,
    status: null,
    totalBankTime: 0,
    totalOfCategoryEmployees: null
  },
  {
    alphaFactor: 50,
    bidMode: null,
    crewGroup: 'cockpit',
    crewInterfaceLastUse: null,
    currentCategory: {
      categoryId: 25,
      categoryName: 'AUH_Airbus_CP',
      equipmentId: 'Airbus',
      lastRefresh: 1668096550212,
      planningCategoryId: 6984,
      seatId: 'CP',
      startDayOffset: 0,
      stationId: 'AUH'
    },
    initialCredit: 243,
    language: null,
    loadStanding: false,
    lockoutExpiryDateLbt: null,
    maximumBlockTime: 133,
    minimumBlockTime: 89,
    name: 'CREWMEMBER_1',
    plannerNote: 'This is a message to YOU, staff id 50549!',
    previousPeriodCredit: 123,
    profileLastSave: null,
    relativeSeniority: null,
    staffId: '50549',
    standingBidSessionId: 3,
    status: null,
    totalBankTime: 0,
    totalOfCategoryEmployees: 0
  },
  {
    alphaFactor: 50,
    bidMode: null,
    crewGroup: 'cabin',
    crewInterfaceLastUse: null,
    currentCategory: {
      categoryId: 12,
      categoryName: 'AUH_CS',
      equipmentId: null,
      lastRefresh: 1668096215830,
      planningCategoryId: 6988,
      seatId: 'CS',
      startDayOffset: 0,
      stationId: 'AUH'
    },
    initialCredit: 543,
    language: null,
    loadStanding: false,
    lockoutExpiryDateLbt: null,
    maximumBlockTime: 234,
    minimumBlockTime: 321,
    name: 'CREWMEMBER_7',
    plannerNote: null,
    previousPeriodCredit: 13,
    profileLastSave: null,
    relativeSeniority: null,
    staffId: '46910897',
    standingBidSessionId: 3,
    status: null,
    totalBankTime: 0,
    totalOfCategoryEmployees: 0
  }
];

export default function () {
  createServer({
    models: {
      bidSession: Model.extend({
        bidPreference: hasMany()
      }),
      employee: Model,
      otherOption: Model,
      filter: Model,
      bidPreferenceClass: Model.extend({
        bidPreferenceOption: hasMany()
      }),
      bidPreferenceOption: Model.extend({
        bidPreferenceClass: belongsTo()
      }),
      classOptionAttribute: Model,
      crewInterfaceMode: Model,
      bidPreference: Model.extend({
        bidSession: belongsTo()
      }),
      activity: Model,
      activityType: Model,
      statistic: Model
    },

    seeds(server) {
      server.create('employee', {
        alphaFactor: 50,
        bidMode: 'MANUAL',
        crewGroup: 'cabin',
        crewInterfaceLastUse: 1667590399477,
        currentCategory: null,
        initialCredit: 0,
        language: { code: 'EN', name: 'English' },
        loadStanding: false,
        lockoutExpiryDateLbt: null,
        maximumBlockTime: null,
        minimumBlockTime: null,
        name: 'Mock Server Administrator',
        plannerNote: null,
        previousPeriodCredit: 0,
        profileLastSave: null,
        relativeSeniority: null,
        staffId: 'Admin',
        standingBidSessionId: 3,
        status: null,
        totalBankTime: 0,
        totalOfCategoryEmployees: null,
        id: 1
      }),
        server.create('employee', {
          alphaFactor: 50,
          bidMode: null,
          crewGroup: 'cockpit',
          crewInterfaceLastUse: null,
          currentCategory: {
            categoryId: 25,
            categoryName: 'AUH_Airbus_CP',
            equipmentId: 'Airbus',
            lastRefresh: 1668096550212,
            planningCategoryId: 6984,
            seatId: 'CP',
            startDayOffset: 0,
            stationId: 'AUH'
          },
          initialCredit: 243,
          language: null,
          loadStanding: false,
          lockoutExpiryDateLbt: null,
          maximumBlockTime: 133,
          minimumBlockTime: 89,
          name: 'CREWMEMBER_1',
          plannerNote: 'This is a message to YOU, staff id 50549!',
          previousPeriodCredit: 123,
          profileLastSave: null,
          relativeSeniority: null,
          staffId: '50549',
          standingBidSessionId: 3,
          status: null,
          totalBankTime: 0,
          totalOfCategoryEmployees: 0,
          id: 2
        }),
        server.create('employee', {
          alphaFactor: 50,
          bidMode: null,
          crewGroup: 'cabin',
          crewInterfaceLastUse: null,
          currentCategory: {
            categoryId: 12,
            categoryName: 'AUH_CS',
            equipmentId: null,
            lastRefresh: 1668096215830,
            planningCategoryId: 6988,
            seatId: 'CS',
            startDayOffset: 0,
            stationId: 'AUH'
          },
          initialCredit: 543,
          language: null,
          loadStanding: false,
          lockoutExpiryDateLbt: null,
          maximumBlockTime: 234,
          minimumBlockTime: 321,
          name: 'CREWMEMBER_7',
          plannerNote: null,
          previousPeriodCredit: 13,
          profileLastSave: null,
          relativeSeniority: null,
          staffId: '46910897',
          standingBidSessionId: 3,
          status: null,
          totalBankTime: 0,
          totalOfCategoryEmployees: 0,
          id: 3
        }),
        server.create('bid-session', {
          applicationType: 'PBS',
          bidSessionId: 42,
          biddingType: 'REGULAR',
          closingBidSessionDate: null,
          closingBidSessionNotifyDate: null,
          enableNotification: null,
          endDate: [2016, 9, 1],
          equipmentId: null,
          id: 42,
          lastSaved: null,
          maximumBidCount: null,
          name: 'Aug-16',
          notificationSent: null,
          openingBidSessionDate: null,
          seatId: null,
          seatType: null,
          startDate: [2016, 8, 1],
          stationId: 'AUH'
        });
      server.create('bid-session', {
        applicationType: 'PBS',
        bidSessionId: 47,
        biddingType: 'REGULAR',
        closingBidSessionDate: null,
        closingBidSessionNotifyDate: null,
        enableNotification: null,
        endDate: [2016, 9, 1],
        equipmentId: null,
        id: 47,
        lastSaved: null,
        maximumBidCount: null,
        name: 'CIP_ReferenceDateOpening',
        notificationSent: null,
        openingBidSessionDate: 1470009600000,
        seatId: null,
        seatType: null,
        startDate: [2016, 8, 1],
        stationId: 'BEG'
      });
      server.create('bid-session', {
        applicationType: 'PBS',
        bidSessionId: 37,
        biddingType: 'REGULAR',
        closingBidSessionDate: null,
        closingBidSessionNotifyDate: null,
        enableNotification: null,
        endDate: [2014, 7, 1],
        equipmentId: null,
        id: 37,
        lastSaved: null,
        maximumBidCount: null,
        name: 'CIP_BidSession',
        notificationSent: null,
        openingBidSessionDate: null,
        seatId: null,
        seatType: null,
        startDate: [2014, 6, 1],
        stationId: 'SEZ'
      });
      server.create('bid-session', {
        applicationType: 'PBS',
        bidSessionId: 39,
        biddingType: 'REGULAR',
        closingBidSessionDate: null,
        closingBidSessionNotifyDate: null,
        enableNotification: null,
        endDate: [2014, 7, 1],
        equipmentId: null,
        id: 39,
        lastSaved: null,
        maximumBidCount: null,
        name: 'CIP_Manual_BidSession',
        notificationSent: null,
        openingBidSessionDate: null,
        seatId: null,
        seatType: null,
        startDate: [2014, 6, 1],
        stationId: 'SEZ'
      });
      server.create('bid-session', {
        applicationType: 'PBS',
        bidSessionId: 2,
        biddingType: 'REGULAR',
        closingBidSessionDate: null,
        closingBidSessionNotifyDate: null,
        enableNotification: null,
        endDate: [2014, 7, 1],
        equipmentId: null,
        id: 2,
        lastSaved: null,
        maximumBidCount: null,
        name: 'CIP_VacationSlide',
        notificationSent: null,
        openingBidSessionDate: null,
        seatId: null,
        seatType: null,
        startDate: [2014, 6, 1],
        stationId: null
      });
      server.create('other-option', {
        description:
          "Allow to exceed the maximum credit time in a line. Select 'Desire Time' bid to favor lines effectively exceeding the maximum credit.",
        name: 'Volunteer for exceeding maximum credit time in a line',
        otherOptionCode: 1,
        readOnly: false,
        value: false
      });
      server.create('other-option', {
        description: 'PNT Waives the rule of a maximum of 6 consecutive GDOs.',
        name: 'Waives the rule of a maximum of 6 consecutive GDOs',
        otherOptionCode: 2,
        readOnly: false,
        value: false
      });
      server.create('other-option', {
        description:
          'PNT wishes to set the number of times the rule of a maximum of one 6-day pairing per month is waived.',
        name: 'Waives the rule of a maximum of one 6-day pairing',
        otherOptionCode: 3,
        readOnly: false,
        value: false
      });
      server.create('other-option', {
        description: 'PNT Volunteer for a block over 90 hours',
        name: 'Volunteer for a block over 90 hours',
        otherOptionCode: 6,
        readOnly: false,
        value: false
      });
      server.create('filter', {
        id: 'ACTIVITY_TYPES',
        isUserAdded: false,
        items: [
          { value: 'RB', name: 'RB', description: 'Reserve Block' },
          { value: 'TRP', name: 'TRP', description: 'Trip' }
        ],
        name: 'Activity Types',
        type: 'list'
      });
      server.create('filter', {
        id: 'ACTIVITY_ATTRIBUTES',
        isUserAdded: false,
        items: [],
        name: 'Activity Attributes',
        type: 'list'
      });
      server.create('filter', {
        id: 'LAYOVERS',
        isUserAdded: false,
        items: [
          { value: 'DME', name: 'DME', description: 'Moscow Domodedovo Apt' },
          { value: 'FRA', name: 'FRA', description: 'FRANKFURT, GERMANY' }
        ],
        name: 'Layovers',
        type: 'list'
      });

      server.create('crew-interface-mode', {
        vacationBufferCustomMode: false,
        vacationSlideCustomMode: true
      });
      server.create('bid-preference', {
        adminComments: null,
        adminName: null,
        bidAggregateId: 392,
        bidInfoDtos: null,
        bidMode: '',
        bidSessionId: 42,
        bidSessionSnapshotId: null,
        description:
          'Desire Period of Dates Off:  Monday August 1 -  Monday August 1 ',
        employeeBidId: 242,
        maxnn: null,
        parameterValues: [
          {
            bidId: 362,
            parameterAttributeId: null,
            parameterId: 2161,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterSequence: 1,
            parameterValueId: 422,
            value: '2016-08-01',
            newEntry: ''
          }
        ],
        preferenceOptionId: 216,
        preferenceOptionPropertyId: 0,
        score: 1,
        staffId: '50549',
        wish: true,
        newEntry: ''
      });
      server.create('bid-preference', {
        adminComments: null,
        adminName: null,
        bidAggregateId: 303,
        bidInfoDtos: null,
        bidMode: '',
        bidSessionId: 42,
        bidSessionSnapshotId: null,
        description: 'Desire Carryover greater than 5  Days',
        employeeBidId: 242,
        maxnn: null,
        parameterValues: [
          {
            bidId: 273,
            parameterAttributeId: null,
            parameterId: 1181,
            parameterRelation: 'GREATER_THAN_RELATION_CODE',
            parameterSequence: 1,
            parameterValueId: 334,
            value: '5',
            newEntry: ''
          }
        ],
        preferenceOptionId: 118,
        preferenceOptionPropertyId: 0,
        score: 2,
        staffId: '46910897',
        wish: true,
        newEntry: ''
      });

      server.create('bid-preference', {
        adminComments: null,
        adminName: null,
        bidAggregateId: 362,
        bidInfoDtos: null,
        bidMode: '',
        bidSessionId: 42,
        bidSessionSnapshotId: null,
        description: 'Desire Work On  Thursday ',
        employeeBidId: 242,
        maxnn: null,
        parameterValues: [
          {
            bidId: 332,
            parameterAttributeId: null,
            parameterId: 2191,
            parameterRelation: 'EQUAL_RELATION_CODE',
            parameterSequence: 1,
            parameterValueId: 392,
            value: '4'
          }
        ],
        preferenceOptionId: 219,
        preferenceOptionPropertyId: 0,
        score: 2,
        staffId: '50549',
        wish: true
      });

      server.create('bid-preference-class', {
        appliesKey: 'bid.class.apply.both',
        descriptionKey: 'bc.date.and.time.off',
        imageKey: 'bid.icon.off',
        name: 'Time Off',
        preferenceClassId: 1
      });

      server.create('bid-preference-class', {
        appliesKey: 'bid.class.apply.regular',
        descriptionKey: 'bc.pairing',
        imageKey: 'bid.icon.pairing',
        name: 'Pairing',
        preferenceClassId: 2
      });
      server.create('bid-preference-class', {
        appliesKey: 'bid.class.apply.both',
        descriptionKey: 'bc.pairing.layover',
        imageKey: 'bid.icon.pairing',
        name: 'Pairing Layover',
        preferenceClassId: 3
      });
      server.create('bid-preference-option', {
        applicationType: 'PBS',
        description: 'Request all of the date(s) off in the selected range.',
        desireFixed: true,
        name: 'Period Of Dates Off',
        preferenceClassId: 1,
        preferenceOptionId: 216
      });
      server.create('bid-preference-option', {
        applicationType: 'PBS',
        description:
          'Desire or avoid pairings based on the number of days. E.g., Desire trips greater than 4 days.',
        desireFixed: false,
        name: 'Pairing Length in Days',
        preferenceClassId: 2,
        preferenceOptionId: 115
      });
      server.create('bid-preference-option', {
        applicationType: 'PBS',
        description: 'Desire or avoid layovers based on length.',
        desireFixed: false,
        name: 'Layover Duration',
        preferenceClassId: 3,
        preferenceOptionId: 265
      });

      server.create('class-option-attribute', {
        applicationType: 'PBS',
        description: 'Request all of the date(s) off in the selected range.',
        desireFixed: true,
        name: 'Period Of Dates Off',
        parameters: [
          {
            allowedValues: null,
            applyRule: '',
            applyRuleKey: 'bid.option.216.apply.1',
            attribute: { attributeId: 14, type: 2, name: 'listable date' },
            defaultValue: '2016-08-01',
            description: 'From',
            descriptionKey: 'bid.option.216.param.1',
            formatKey: 'bid.option.216.format.1',
            mandatory: true,
            maxValue: '2016-08-31',
            minValue: '2016-08-01',
            notAllowedValues: null,
            parameterId: 2161,
            parentParameterId: null,
            sequence: 1,
            validRelations: ['EQUAL_RELATION_CODE']
          },
          {
            allowedValues: null,
            applyRule:
              'Request a period of dates off.<br/>Requests are only applicable to days of the bid period. A requested period conflicting with a carry-in activity is automatically adjusted to start at the end of the carry-in.<br/> Example: 100 pts Desire Period of Jan 20 to Jan 31 Off',
            applyRuleKey: 'bid.option.216.apply.2',
            attribute: { attributeId: 14, type: 2, name: 'listable date' },
            defaultValue: '2016-08-01',
            description: 'To',
            descriptionKey: 'bid.option.216.param.2',
            formatKey: 'bid.option.216.format.2',
            mandatory: true,
            maxValue: '2016-08-31',
            minValue: '2016-08-01',
            notAllowedValues: null,
            parameterId: 2162,
            parentParameterId: null,
            sequence: 2,
            validRelations: ['EQUAL_RELATION_CODE']
          }
        ],
        preferenceClassId: 1,
        preferenceOptionId: 216,
        properties: [
          { propertyId: 1, name: 'Default' },
          { propertyId: 5, name: 'Award' },
          { propertyId: 7, name: 'CalendarMultiDates' },
          { propertyId: 200, name: 'Participating' },
          { propertyId: 11, name: 'XXn' },
          { propertyId: 13, name: 'Score' },
          { propertyId: 15, name: 'Reserve' },
          { propertyId: 0, name: 'Regular' }
        ]
      });
      server.create('class-option-attribute', {
        applicationType: 'PBS',
        description:
          'Desire or avoid pairings based on the number of days. E.g., Desire trips greater than 4 days.',
        desireFixed: false,
        name: 'Pairing Length in Days',
        parameters: [
          {
            allowedValues: null,
            applyRule:
              'Request pairings to be less than, equal or greater than a specified number of working days.<br/> Example: 100 pts Desire Pairing Length In Days = 3.',
            applyRuleKey: 'bid.option.115.apply.1',
            attribute: { attributeId: 18, type: 1, name: 'quan' },
            defaultValue: '1',
            description: 'Pairing Length In Days',
            descriptionKey: 'bid.option.115.param.1',
            formatKey: 'bid.option.115.format.1',
            mandatory: true,
            maxValue: '15',
            minValue: '1',
            notAllowedValues: null,
            parameterId: 1151,
            parentParameterId: null,
            sequence: 1,
            validRelations: [
              'LESS_THAN_RELATION_CODE',
              'EQUAL_RELATION_CODE',
              'GREATER_THAN_RELATION_CODE'
            ]
          }
        ],
        preferenceClassId: 2,
        preferenceOptionId: 115,
        properties: [
          { propertyId: 1, name: 'Default' },
          { propertyId: 2, name: 'MaxNN' },
          { propertyId: 3, name: 'Default to award' },
          { propertyId: 4, name: 'Avoid' },
          { propertyId: 5, name: 'Award' },
          { propertyId: 200, name: 'Participating' },
          { propertyId: 13, name: 'Score' },
          { propertyId: 0, name: 'Regular' }
        ]
      });
      server.create('class-option-attribute', {
        applicationType: 'PBS',
        description: 'Desire or avoid layovers based on length.',
        desireFixed: false,
        name: 'Layover Duration',
        parameters: [
          {
            allowedValues: null,
            applyRule:
              'Identify layovers (less than / greater than) a specified duration regardless to location.<br/><br/><b>Example</b>:<br/>100 pts Avoid Layover Duration < 2h00.',
            applyRuleKey: 'bid.option.265.apply.1',
            attribute: { attributeId: 15, type: 31, name: 'duration' },
            defaultValue: '0',
            description: 'Layover Duration',
            descriptionKey: 'bid.option.265.param.1',
            formatKey: 'bid.option.265.format.1',
            mandatory: true,
            maxValue: '5400',
            minValue: '0',
            notAllowedValues: null,
            parameterId: 2651,
            parentParameterId: null,
            sequence: 1,
            validRelations: [
              'EQUAL_RELATION_CODE',
              'GREATER_THAN_RELATION_CODE',
              'LESS_THAN_RELATION_CODE'
            ]
          }
        ],
        preferenceClassId: 3,
        preferenceOptionId: 265,
        properties: [
          { propertyId: 1, name: 'Default' },
          { propertyId: 2, name: 'MaxNN' },
          { propertyId: 3, name: 'Default to award' },
          { propertyId: 4, name: 'Avoid' },
          { propertyId: 5, name: 'Award' },
          { propertyId: 200, name: 'Participating' },
          { propertyId: 13, name: 'Score' },
          { propertyId: 0, name: 'Regular' }
        ]
      });

      // #region Activities
      server.create('activity', {
        active: false,
        activityId: 377176,
        blockTime: null,
        borderColor: '#FFC701',
        credit: 0,
        endDate: 1471048140000,
        isModifiedFromOriginal: null,
        isVacationEditable: false,
        lineNumber: null,
        name: null,
        originalEndDate: 1471048140000,
        originalStartDate: 1470961740000,
        restTimeAfter: null,
        source: 2,
        startDate: 1470961740000,
        status: null,
        type: 'VAE',
        typeName: null,
        vacationSlideEndDate: null,
        vacationSlideStartDate: null,
        validatedVacationSlideEndDate: null,
        validatedVacationSlideStartDate: null
      });
      server.create('activity', {
        active: false,
        activityId: 377177,
        blockTime: null,
        borderColor: '#FFC701',
        credit: 0,
        endDate: 1471134540000,
        isModifiedFromOriginal: null,
        isVacationEditable: false,
        lineNumber: null,
        name: null,
        originalEndDate: 1471134540000,
        originalStartDate: 1471048140000,
        restTimeAfter: null,
        source: 2,
        startDate: 1471048140000,
        status: null,
        type: 'VAE',
        typeName: null,
        vacationSlideEndDate: null,
        vacationSlideStartDate: null,
        validatedVacationSlideEndDate: null,
        validatedVacationSlideStartDate: null
      });
      server.create('activity', {
        active: false,
        activityId: 377178,
        blockTime: null,
        borderColor: '#FFC701',
        credit: 0,
        endDate: 1471220940000,
        isModifiedFromOriginal: null,
        isVacationEditable: false,
        lineNumber: null,
        name: null,
        originalEndDate: 1471220940000,
        originalStartDate: 1471134540000,
        restTimeAfter: null,
        source: 2,
        startDate: 1471134540000,
        status: null,
        type: 'VAE',
        typeName: null,
        vacationSlideEndDate: null,
        vacationSlideStartDate: null,
        validatedVacationSlideEndDate: null,
        validatedVacationSlideStartDate: null
      });

      server.create('activity', {
        active: true,
        activityId: 377173,
        blockTime: null,
        credit: 0,
        endDate: 1471480140000,
        isModifiedFromOriginal: null,
        isVacationEditable: false,
        lineNumber: null,
        name: null,
        originalEndDate: 1471480140000,
        originalStartDate: 1471220940000,
        restTimeAfter: null,
        source: 2,
        startDate: 1471220940000,
        status: null,
        type: 'VAC',
        typeName: null,
        vacationSlideEndDate: null,
        vacationSlideStartDate: null,
        validatedVacationSlideEndDate: null,
        validatedVacationSlideStartDate: null
      });
      server.create('activity', {
        active: false,
        activityId: 377179,
        blockTime: null,
        borderColor: '#FFC701',
        credit: 0,
        endDate: 1471566540000,
        isModifiedFromOriginal: null,
        isVacationEditable: false,
        lineNumber: null,
        name: null,
        originalEndDate: 1471566540000,
        originalStartDate: 1471480140000,
        restTimeAfter: null,
        source: 2,
        startDate: 1471480140000,
        status: null,
        type: 'VAE',
        typeName: null,
        vacationSlideEndDate: null,
        vacationSlideStartDate: null,
        validatedVacationSlideEndDate: null,
        validatedVacationSlideStartDate: null
      });
      server.create('activity', {
        active: false,
        activityId: 377180,
        blockTime: null,
        borderColor: '#FFC701',
        credit: 0,
        endDate: 1471652940000,
        isModifiedFromOriginal: null,
        isVacationEditable: false,
        lineNumber: null,
        name: null,
        originalEndDate: 1471652940000,
        originalStartDate: 1471566540000,
        restTimeAfter: null,
        source: 2,
        startDate: 1471566540000,
        status: null,
        type: 'VAE',
        typeName: null,
        vacationSlideEndDate: null,
        vacationSlideStartDate: null,
        validatedVacationSlideEndDate: null,
        validatedVacationSlideStartDate: null
      });
      server.create('activity', {
        active: false,
        activityId: 377181,
        blockTime: null,
        borderColor: '#FFC701',
        credit: 0,
        endDate: 1471739340000,
        isModifiedFromOriginal: null,
        isVacationEditable: false,
        lineNumber: null,
        name: null,
        originalEndDate: 1471739340000,
        originalStartDate: 1471652940000,
        restTimeAfter: null,
        source: 2,
        startDate: 1471652940000,
        status: null,
        type: 'VAE',
        typeName: null,
        vacationSlideEndDate: null,
        vacationSlideStartDate: null,
        validatedVacationSlideEndDate: null,
        validatedVacationSlideStartDate: null
      });

      server.create('activity-type', {
        activityTypeId: 'VAC',
        backgroundColor: -6710785,
        backgroundColorHex: '#9999FF',
        endTime: null,
        foregroundColor: -16777216,
        foregroundColorHex: '#000000',
        name: 'Vacation',
        startTime: null,
        timePolicyTreatment: 1
      });

      server.create('activity-type', {
        activityTypeId: 'VAE',
        backgroundColor: -6710785,
        backgroundColorHex: '#FFFFFF',
        borderColor: '#FFC701',
        endTime: null,
        foregroundColor: -16777216,
        foregroundColorHex: '#000000',
        name: 'Vacation Extra',
        startTime: null,
        timePolicyTreatment: 1
      });

      server.create('statistic', {
        result: 'UNAVAILABLE',
        resultReason: 'AltitudeBidStatisticService unreachable',
        response: {
          end: 0,
          entries: [],
          start: 0,
          totalEntries: 0
        }
      });

      // #endregion
    },

    routes() {
      this.namespace = 'api';

      this.post('/auth/login', (schema, request) => {
        const args = JSON.parse(request.requestBody);
        // const payload = { staffId: args.staffId, password: args.password };
        const token =
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGFmZklkIjoiQWRtaW4iLCJwYXNzd29yZCI6IiIsImlhdCI6MTY2OTE0NjkxOSwiZXhwIjoxNjY5MTc1NzE5fQ.iRF0_aCZ_0awZd19iG3JwdzT21lD-B0LQd30PAnr4yk';

        const user = userDb.find(take => take.staffId === args.staffId);

        return { user, token };
      });

      this.get('/auth/token', (schema, request) => {
        const args = JSON.parse(request.requestBody);
        // const payload = { staffId: args.staffId, password: args.password };
        const token =
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGFmZklkIjoiQWRtaW4iLCJwYXNzd29yZCI6IiIsImlhdCI6MTY2OTE0NjkxOSwiZXhwIjoxNjY5MTc1NzE5fQ.iRF0_aCZ_0awZd19iG3JwdzT21lD-B0LQd30PAnr4yk';

        const user = userDb.find(take => take.staffId === args.staffId);

        return { user, token };
      });

      this.get('/employees/:id', (schema, request) => {
        const staffId = request.params.id;
        const employee = userDb.find(user => user.staffId === staffId);
        // const employee = schema.employees.find(staffId);
        return employee;
      });

      this.get('/employees/all-employees', (schema, request) => ({ data: schema.employees.all().models }));

      this.get('/profiles/:id', schema => schema.bidSessions.all());

      this.get('/bid-sessions', (schema) => {
        const entries = schema.bidSessions.all().models;
        const totalEntries = entries.length;
        const end = totalEntries;
        const start = 0;

        return { end, entries, start, totalEntries };
      });

      this.post('/bid-session', async (schema, request) => {
        const attrs = await JSON.parse(request.requestBody);
        return schema.bidSessions.create(attrs);
      });

      this.get('/preferences/bid-sessions', async (schema, request) => {
        const entries = schema.bidSessions.all().models;
        const totalEntries = entries.length;
        const end = totalEntries;
        const start = 0;

        return { end, entries, start, totalEntries };
      });

      // #region BID-SESSION SCENE

      this.get('preferences/options/other', (schema, request) => {
        const entries = schema.otherOptions.all().models;

        const totalEntries = entries.length;
        const end = totalEntries;
        const start = 0;

        return { end, entries, start, totalEntries };
      });

      this.get('filters', (schema, request) => {
        const entries = schema.filters.all().models;

        const totalEntries = entries.length;
        const end = totalEntries;
        const start = 0;

        return { end, entries, start, totalEntries };
      });

      this.get('activities/crewinterface-mode', (schema, request) => schema.crewInterfaceModes.all().models);

      this.get(
        'preferences/bid-session/:bidSessionId/employee/:staffId',
        (schema, request) => {
          const bidSessionId = parseInt(request.params.bidSessionId);
          const staffId = request.params.staffId;

          const bidPreferences = schema.bidPreferences.all().models;
          const entries = bidPreferences
            .map((pref) => {
              if (
                pref.attrs.bidSessionId === bidSessionId &&
                pref.attrs.staffId === staffId
              ) { return pref.attrs; }
            })
            .filter((unit) => {
              if (unit && unit.staffId) return unit;
            });

          const totalEntries = entries.length;
          const end = totalEntries;
          const start = 0;

          return { end, entries, start, totalEntries };
        }
      );

      // #region preference dialog api
      this.get('preference/classes', (schema, request) => {
        const entries = schema.bidPreferenceClasses.all().models;

        const totalEntries = entries.length;
        const end = totalEntries;
        const start = 0;

        return { end, entries, start, totalEntries };
      });

      this.get('preferences/options', (schema, request) => {
        const entries = schema.bidPreferenceOptions.all().models;

        const totalEntries = entries.length;
        const end = totalEntries;
        const start = 0;

        return { end, entries, start, totalEntries };
      });

      this.get(
        'preferences/options/:optionClassId/bidsession_id/:bidSessionId/staffId/:staffId',
        (schema, request) => {
          const optionClassId = request.params.optionClassId;
          const classOptionAttributes =
            schema.classOptionAttributes.all().models;

          const classOptionAttribute = classOptionAttributes.find(
            option => option.optionClassId === optionClassId
          );

          return classOptionAttribute;
        }
      );

      // INCOMPLETE
      this.post(buildUrlWithAdminImpersonation('preferences/save'), (schema, request) => {
        const attrs = JSON.parse(request.requestBody);
        console.log(attrs);
        schema.bidPreferences.create(attrs);

        const res = {};
        return res;
      });
      // #endregion

      this.get('activities/preassignments', (schema, request) => {
        const entries = schema.activities.all().models;

        const totalEntries = entries.length;
        const end = totalEntries;
        const start = 0;

        return { end, entries, start, totalEntries };
      });

      this.post(
        'activities/preassignments/update/activitieId',
        (schema, request) => {
          const req = JSON.parse(request.requestBody);
          const newBuffer = schema.activities.findBy({
            startDate: req.request.date
          });
          schema.activities.all().models;

          const newBufferId = newBuffer.attrs.id;

          let newBufferDay;
          let newBufferDayActive;
          if (newBufferId === '7') {
            // BUFFER DAY #7 CLICK
            for (let i = 7; i >= 1; i--) {
              newBufferDay = schema.activities.findBy({
                id: i
              });
              if (i === 7) {
                newBufferDay.update({ active: !newBufferDay.active });
                newBufferDayActive = newBufferDay.active;
              }

              if (i === 5 || i === 6) {
                if (newBufferDayActive) newBufferDay.update({ active: true });
                else if (!newBufferDayActive && newBufferDay.active) continue;
                else newBufferDay.update({ active: false });
              }

              if (i < 4) newBufferDay.update({ active: false });
            }
          } else if (newBufferId === '6') {
            // BUFFER DAY #6 CLICK
            newBufferDay = schema.activities.findBy({
              id: '7'
            });
            newBufferDay.update({ active: false });

            newBufferDay = schema.activities.findBy({
              id: newBufferId
            });
            newBufferDay.update({ active: !newBufferDay.active });
            newBufferDayActive = newBufferDay.active;

            for (let i = 5; i >= 1; i--) {
              newBufferDay = schema.activities.findBy({
                id: i
              });
              if (i === 5) {
                if (newBufferDayActive && newBufferDay.active) continue;
                else if (newBufferDayActive && !newBufferDay.active)
                  newBufferDay.update({ active: true });
                else if (!newBufferDayActive && newBufferDay.active) continue;
                else newBufferDay.update({ active: false });
              } else if (i === 3) {
                if (newBufferDay.active) continue;
                else newBufferDay.update({ active: false });
              } else if (i < 3) newBufferDay.update({ active: false });
            }
          } else if (newBufferId === '5') {
            // BUFFER DAY #5 CLICK
            newBufferDay = schema.activities.findBy({
              id: '7'
            });
            newBufferDay.update({ active: false });

            newBufferDay = schema.activities.findBy({
              id: '6'
            });
            newBufferDay.update({ active: false });

            newBufferDay = schema.activities.findBy({
              id: newBufferId
            });
            newBufferDay.update({ active: !newBufferDay.active });
            newBufferDayActive = newBufferDay.active;

            for (let i = 3; i >= 1; i--) {
              newBufferDay = schema.activities.findBy({
                id: i
              });
              if (i === 3 || i == 2) {
                if (newBufferDayActive && newBufferDay.active) continue;
                else if (newBufferDayActive && !newBufferDay.active) continue;
                else if (!newBufferDayActive && newBufferDay.active) continue;
                else newBufferDay.update({ active: false });
              }
              if (i === 1) newBufferDay.update({ active: false });
            }
          } else if (newBufferId === '3') {
            // BUFFER DAY #3 CLICK
            newBufferDay = schema.activities.findBy({
              id: '7'
            });
            newBufferDay.update({ active: false });

            newBufferDay = schema.activities.findBy({
              id: newBufferId
            });
            newBufferDay.update({ active: !newBufferDay.active });
            newBufferDayActive = newBufferDay.active;
            for (let i = 6; i >= 1; i--) {
              newBufferDay = schema.activities.findBy({
                id: i
              });
              if (i === 5 || i === 6) {
                if (newBufferDayActive && newBufferDay.active) continue;
                else if (!newBufferDayActive && newBufferDay.active) continue;
                else newBufferDay.update({ active: false });
              }

              if (i < 3) newBufferDay.update({ active: false });
            }
          } else if (newBufferId === '2') {
            // BUFFER DAY #2 CLICK
            newBufferDay = schema.activities.findBy({
              id: '1'
            });
            newBufferDay.update({ active: false });

            newBufferDay = schema.activities.findBy({
              id: '2'
            });
            newBufferDay.update({ active: !newBufferDay.active });
            newBufferDayActive = newBufferDay.active;

            for (let i = 3; i <= 7; i++) {
              newBufferDay = schema.activities.findBy({
                id: i
              });
              if (i === 3) {
                if (newBufferDay.active) continue;
                else newBufferDay.update({ active: newBufferDayActive });
              }
              if (i === 5 && newBufferDay.active) continue;
              if (i >= 6) newBufferDay.update({ active: false });
            }
          } else if (newBufferId === '1') {
            // BUFFER DAY #1 CLICK
            newBufferDay = schema.activities.findBy({
              id: newBufferId
            });
            newBufferDay.update({ active: !newBufferDay.active });
            newBufferDayActive = newBufferDay.active;

            for (let i = 2; i <= 7; i++) {
              newBufferDay = schema.activities.findBy({
                id: i
              });

              if (i === 2 || i === 3) {
                newBufferDay.update({ active: newBufferDayActive });
              }

              if (i > 4) newBufferDay.update({ active: false });
            }
          }

          return schema.activities.all();
        }
      );

      this.get('activities/types', (schema, request) => {
        const entries = schema.activityTypes.all().models;

        const totalEntries = entries.length;
        const end = totalEntries;
        const start = 0;

        return { end, entries, start, totalEntries };
      });

      this.get(
        'preferences/statistics/bid-session/:bidSessionId/category/:categoryId/employee/:staffId',
        (schema, request) => {
          const entries = schema.statistics.all().models;
          return { data: entries[0] };
        }
      );

      // #endregion
    }
  });
}
